import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { AppConstant } from '@app/shared/constants';

@Injectable({
  providedIn: 'root'
})
export class StoreCategoryService {

  constructor(private httpClient: HttpClient) { }

  CreateCategory(data: any) {
    return this.httpClient.post(environment.baseUrl + AppConstant.CREATE_STORECATEGORY, data);
  }
}
